import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './i18n/rtl.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import I18nProvider from './i18n/I18nProvider';
import ToastContainerRtl from './components/common/ToastContainerRtl';
import { store } from './store';
import { initAnalytics } from './utils/analytics';
import './api/setupLanguageHeaders';

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <App />
            <ToastContainerRtl />
          </ErrorBoundary>
        </BrowserRouter>
      </I18nProvider>
    </Provider>
  </React.StrictMode>
);
